import { AuthProvider, UserProvider } from '@myosh/myosh-login';
import { BrowserRouter as Router } from 'react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RoutesComponent from './components/routing/routes.component';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AuthProvider>
        <UserProvider>
          <RoutesComponent />
        </UserProvider>
      </AuthProvider>
      <ToastContainer position="top-center" hideProgressBar />
    </Router>
  );
}

export default App;
